// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.
import { TopbarUserMenu } from './topbar-user-menu';
import { SwitchAccountType } from './switch-account-type';
import { AssetsSearch } from './assets-search';
import { SwitchCurrency } from './switch-currency';
import { LanguageSelector } from '@shared/ui-kit/components/language-selector';
import { AppIcon } from '@shared/ui-kit/components/app-icon';

interface TopbarProps {
  hidden?: boolean;
  onOpenSidebar?: () => void;
}

export const Topbar = ({ hidden, onOpenSidebar }: TopbarProps) => {
  return (
    <div
      data-testid="topbar"
      className="sticky top-0 z-50 flex w-full bg-page px-4 py-6 lg:px-8 lg:py-8 xl:px-16 xl:py-10"
    >
      <div
        className="flex min-w-0 flex-1 items-center justify-between gap-2 lg:justify-start lg:gap-4"
        data-testid="topbar-search"
      >
        {onOpenSidebar ? (
          <button
            type="button"
            className="flex shrink-0 items-center justify-center rounded-lg p-2 text-title-alt xl:hidden"
            onClick={onOpenSidebar}
            data-testid="topbar-menu-button"
            aria-label="Open navigation menu"
          >
            <AppIcon icon="Menu" size="xl" color="main" />
          </button>
        ) : null}

        {!hidden ? (
          <div className="hidden min-w-0 flex-1 lg:block">
            <AssetsSearch />
          </div>
        ) : (
          <div className="flex-1" />
        )}

        <div className="hidden items-center gap-2 xl:flex xl:gap-4">
          {!hidden ? (
            <>
              <SwitchCurrency />
              <SwitchAccountType />
            </>
          ) : null}
          <div className="text-title-alt">
            <LanguageSelector />
          </div>
        </div>

        <TopbarUserMenu />
      </div>
    </div>
  );
};
